import { apiUc, apiInstagramChat as apiChatTs } from '../http';

import ServiceCRUD from './ServiceCRUDFLEXUC';

class ServicePAUSES extends ServiceCRUD {
  constructor() {
    super(`/api/pausas`);
  }

  getAllPauses() {
    return apiUc.get(`/api/pausas`);
  }

  getPausesByUserPermission() {
    return apiUc.get('/api/pausas/by-user');
  }

  pauseAgent(login, pauseId) {
    return apiChatTs.post(
      `/agent-status-chat/pause-queue-chat/${login}/${pauseId}`
    );
  }

  unpauseAgent(login) {
    return apiChatTs.post(`/agent-status-chat/unpause-queue-chat/${login}`);
  }
}

export default new ServicePAUSES();
